// Safe markdown renderer for chat replies. Renders bold, lists, links,
// and paragraphs from the model's reply. Strict allowlist via the
// element overrides: no raw HTML, no scripts, no iframes. Links open
// in a new tab with rel=noopener noreferrer.

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function ChatMarkdown({ text }: { text: string }): JSX.Element {
  return (
    <div className="chat-markdown">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: (props) => (
            <a {...props} target="_blank" rel="noopener noreferrer">
              {props.children}
            </a>
          ),
          // Block raw HTML and embedded media for safety.
          script: () => null,
          iframe: () => null,
          img: () => null,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
